var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7610_73944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 17.25H12.4583C12.9854 17.25 13.4167 16.8187 13.4167 16.2917C13.4167 15.7646 12.9854 15.3333 12.4583 15.3333H10.5417C10.0146 15.3333 9.58333 15.7646 9.58333 16.2917C9.58333 16.8187 10.0146 17.25 10.5417 17.25ZM2.875 6.70833C2.875 7.23542 3.30625 7.66667 3.83333 7.66667H19.1667C19.6938 7.66667 20.125 7.23542 20.125 6.70833C20.125 6.18125 19.6938 5.75 19.1667 5.75H3.83333C3.30625 5.75 2.875 6.18125 2.875 6.70833ZM6.70833 12.4583H16.2917C16.8187 12.4583 17.25 12.0271 17.25 11.5C17.25 10.9729 16.8187 10.5417 16.2917 10.5417H6.70833C6.18125 10.5417 5.75 10.9729 5.75 11.5C5.75 12.0271 6.18125 12.4583 6.70833 12.4583Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7610_73944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.20fab1473dd476f6dc39aef81e880505.svg";
export { ForwardRef as ReactComponent };